import moment from "moment";

export const dateToString = (d: Date) => {
    return moment(d).format("DD MMM YYYY");
    const date = new Date(d)
    const day = date.getDate()
    const month = date.getMonth()
    const year = date.getFullYear()
    const dayLabel = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][date.getDay()]
    const monthLabel = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][month]
    const dateString = `${dayLabel} ${day} ${monthLabel} ${year}`
    return dateString;
};
export const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
